import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Grid, Box, Container } from "@mui/material";

export default function Page() {
  const [terms, setTerms] = useState("");

  useEffect(() => {
    fetch("/texts/terms.md")
      .then((res) => res.text())
      .then(setTerms);
  }, []);

  return (
    <Container maxWidth="lg">
      <Grid container justifyContent="center">
        {/* Spacer (2/12 left side) */}
        <Grid item xs={12} md={8}>
          <Box sx={{ pt: 6 }}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {terms}
            </ReactMarkdown>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}